/**
 * String interpolation
 *
 * @module StringInterpolate
 * @class StringInterpolate
 */
define(
    'utils/string-interpolate',[], function () {
        'use strict';

        /**
         * Takes a string and one or multiple values passed as an array.
         *
         * Use "%s" to set out points of interpolation, eg.
         * "I searched for my dear pig %s, but never found him"
         * Numbered positions will work as well.
         * "I searched for my dear pig at %2, but found him at %1"
         *
         * @method interpolate
         * @param string {String}
         * @param values {Array} List of values to use, should be in the same order
         * as in the string
         * @return {String} The interpolated string
         */
        return function (string, values) {
            if (typeof string !== 'string') {
                throw "String needs to be a string.";
            }

            if (typeof values !== 'object') {
                throw "Values needs to be an array.";
            }

            for (var i = 0; i < values.length; i++) {
                string = string.replace('%s', values[i]);
                string = string.replace('%' + (i + 1), values[i]);
            }

            return string;
        };
    }
);
